module.exports = __webpack_public_path__ + "img/DL.1a5f9706.jpg";